//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'product-card-audio-play-button',
  props: {
    element: Object,
    classPlayStatus: Object,
  },
  methods: {
    clickAudioPlayButton() {
      this.$emit('click-audio-play-button');
    },
  },
};
